module.exports = __webpack_public_path__ + "assets/img/7.b3ea7feb.png";